export default __webpack_public_path__ + "static/media/icon_posologia.219c406e.svg";